<template>
<div class="chapter">
<div class="inner_page">
<p><br/><br/><br/></p>
<p class="ctc" id="d7e118715"><img alt="2" src="images/2.jpg" style="max-width:100%;"/>   <a href="#/Mark_9781595553966_epub_c18_r1#Anch00115" id="Anch0005">PART I</a>   <img alt="2" src="images/2.jpg" style="max-width:100%;"/></p>
<p class="imgpub"><img alt="1" src="images/1.jpg" style="max-width:100%;"/></p><p class="ctc" id="d9t00115"><a href="#/Mark_9781595553966_epub_c18_r1#Anch00115" id="Anch001105">W<span class="small">ISDOM FOR</span> Y<span class="small">OUR</span><br/>P<span class="small">ROFESSIONAL</span> L<span class="small">IFE</span></a></p>
<p class="extc" id="d7e121115"><i>Wisdom is the principal thing; <br/>therefore get wisdom.</i><br/><span class="small">—Proverbs 4:7 (<span class="small">KJV</span>)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mark_9781595553966_epub_c20_r1.vue?564e4f93